// @flow

import {
  RETURN_REQUEST_ON_CHANGE,
  RETURN_ITEM_ON_CHANGE,
  CREATE_UPDATE_RETURN_ITEM,
  UPDATE_RETURN_ITEM,
  CREATE_OR_UPDATE_POLICY_SUCCESS,
  CREATE_OR_UPDATE_POLICY_FAILED,
  GET_POLICY_BY_ID_SUCCESS,
  GET_POLICY_BY_ID_FAILED,
  COMMENT_ON_CHANGE,
  ADD_COMMENT_SUCCESS,
  ADD_COMMENT_FAILED,
} from '../constants'

import type { Policy, WarehouseRecord } from '../types'


const initialState = {
  returnRequest: {
    policy: {
      extRef: '',
      merchantComments: '',
      coverages: [],
      notes: [],
    }
  },
  itemModal: {
    name: '',
    description: '',
    quantity: '',
    taobaoProductId: '',
    coverageAmount: '',
    currency: 'CNY',
    claims: [{
      claimAmount: '',
      returnQuantity: '',
      warehouseLocation: '',
      deliveryTrackingNumber: '',
    }]
  },
  error: '',
  warehouseRecords: [],
  storeName: '',
  comment: '',
  users: {}
}

type InitialState = {
  returnRequest: {
    policy: Policy
  },
  error: string,
  warehouseRecords: Array<WarehouseRecord>,
  users: any,
}

function returnDetails(state: InitialState = initialState, action: { type: string, payload: any }) {
  switch (action.type) {
    case RETURN_REQUEST_ON_CHANGE:
      if (action.payload.policy.notes) {
        action.payload.policy.notes.sort((a, b) => a.createdAt - b.createdAt)
      } else {
        action.payload.policy.notes = []
      }
      return {
        ...state,
        returnRequest: action.payload,
      }
    case GET_POLICY_BY_ID_SUCCESS:
      action.payload.policy.notes.sort((a, b) => a.createdAt - b.createdAt)
      return {
        ...state,
        returnRequest: action.payload,
        warehouseRecords: action.payload.warehouseRecords || [],
        storeName: action.payload.users[0] ? action.payload.users[0].storeName : 'Not set',
        users: action.payload.users.reduce((accumulator, currentUser) => {
        return {
          ...accumulator,
          [currentUser.entityId]: currentUser
        }
      }, {})}
    case RETURN_ITEM_ON_CHANGE:
      return {
        ...state,
        itemModal: action.payload
      }
    case CREATE_UPDATE_RETURN_ITEM:
      return {
        ...state,
        returnRequest: action.payload
      }
    case UPDATE_RETURN_ITEM:
      return {
        ...state,
        itemModal: action.payload
      }
    case CREATE_OR_UPDATE_POLICY_SUCCESS:
      return {
        ...state,
        returnRequest: {
          policy: {
            extRef: '',
            merchantComments: '',
            coverages: [],
            notes: [],
          }
        }
      }
    case CREATE_OR_UPDATE_POLICY_FAILED:
      return {
        ...state,
        error: action.payload
      }
    case GET_POLICY_BY_ID_FAILED:
      return {
        ...state,
        error: action.payload
      }
    case COMMENT_ON_CHANGE:
      return {
        ...state,
        comment: action.payload
      }
    case ADD_COMMENT_SUCCESS:
      return {
        ...state,
        returnRequest: {
          policy: {
            ...state.returnRequest.policy,
            notes: state.returnRequest.policy.notes.concat([action.payload.result.note])
          }
        },
        users: {
          ...state.users,
          [action.payload.result.users[0].entityId]: action.payload.result.users[0]
        },
        comment: ''
      }
    case ADD_COMMENT_FAILED:
      return {
        ...state,
        error: action.payload
      }
    default:
      return state
  }
}

export default returnDetails



// WEBPACK FOOTER //
// ./src/modules/returnDetails.js